export enum EnvironmentName {
  LOCAL,
  POC,
  DEV,
  UAT,
  PPD,
  PRD,
}

export enum ConfigKey {
  ENVIRONMENT = "ENVIRONMENT",
}
